module.exports = __webpack_public_path__ + "img/gb933.asm.0ba72b1d.jpg";